<script setup lang="ts">
import type { Schemas } from "#shopware"

interface ProductCustomFields {
    gisy_description_prange?: string
}

const props = defineProps<{
    product: Schemas["Product"]
}>()

const description = computed(() => (props.product.customFields as ProductCustomFields)?.gisy_description_prange)
</script>

<template>
    <div class="py-6">
        <div
            v-if="description"
            class="prose prose-sm max-w-none"
            v-html="description"
        />
        <p v-else class="text-sm text-gray-500">
            {{ $t('product.accordion.noDescription') }}
        </p>
    </div>
</template>